import type { Category } from '@/mocks/categories';

interface CategoryTabProps {
  categories: Category[];
  activeSlug: string;
  onSelect: (slug: string) => void;
}

export default function CategoryTab({ categories, activeSlug, onSelect }: CategoryTabProps) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <button
        onClick={() => onSelect('all')}
        className={`px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
          activeSlug === 'all'
            ? 'bg-primary-500 text-background-50'
            : 'bg-background-100 text-foreground-600 hover:bg-background-200'
        }`}
      >
        全部
      </button>
      {categories.map((cat) => (
        <button
          key={cat.slug}
          onClick={() => onSelect(cat.slug)}
          className={`flex items-center gap-1.5 px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
            activeSlug === cat.slug
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200'
          }`}
        >
          <i className={`${cat.icon} text-sm`}></i>
          {cat.name}
        </button>
      ))}
    </div>
  );
}